import React from "react";

export default function Wk2DLive({ route = ''}) {
  return (
    <iframe src={`https://weekend2d.com/${route}`} className="h-[100vh] w-full pb-3 rounded-md shadow-md overflow-hidden"></iframe>
  );
}
